import { Modal, TextField } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close";
import { useContext, useState } from "react";
import { useLocation } from "react-router-dom";
import { ITrabalhador } from "../../Interfaces/maoobra/maoobra";
import { AuthContext } from "../../AuthContext/AuthContext";
import { loader } from "../../Func_genericas/loader";
import { cores, mensagem_tem_a_certeza_de_apagar_alteracoes, operacao_erro, operacao_sucesso } from "../../Func_genericas/valores_estaticos";
import Switch from "react-switch";
import { CustomTextField } from "../../Styles/theme/customThemeprovider";
import { del, get, post, put } from "../../Services/tokenConfig";
import { func_print } from "../../Func_genericas/func_print";
import ConfirmDialog from "../../Components/CustomDialog/customdialog";
import { isValidEmail } from "../../Func_genericas/isValidEmail";
import { verify_nif } from "../../Func_genericas/verify_nif";
import PhoneInput from "react-phone-number-input";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

interface I_aux {
    list_trabalhadores: ITrabalhador[],
    flag_open_modal: boolean,
    set_flag_open_modal: React.Dispatch<React.SetStateAction<boolean>>,
    flag_open_modal_ver_mais: boolean,
    set_flag_open_modal_ver_mais: React.Dispatch<React.SetStateAction<boolean>>,
    flag_open_modal_edit: boolean,
    set_flag_open_modal_edit: React.Dispatch<React.SetStateAction<boolean>>,
    flag_open_modal_add: boolean,
    set_flag_open_modal_add: React.Dispatch<React.SetStateAction<boolean>>,
    setMessage: React.Dispatch<React.SetStateAction<string>>,
    setOpenSnackSuccess: React.Dispatch<React.SetStateAction<boolean>>,
    setOpenSnackError: React.Dispatch<React.SetStateAction<boolean>>,
    set_list_trabalhadores: React.Dispatch<React.SetStateAction<ITrabalhador[]>>,
    set_obj_new_trabalhador: React.Dispatch<React.SetStateAction<ITrabalhador | undefined>>,
    obj_new_trabalhador: ITrabalhador | undefined,
    // flag_open_modal_historico_trabalhadores: boolean,
    set_flag_open_modal_historico_trabalhadores: React.Dispatch<React.SetStateAction<boolean>>,
    set_historico: React.Dispatch<React.SetStateAction<any>>,

}

export const Modaladdtrabalhadores: React.FC<I_aux> = ({
    list_trabalhadores,
    flag_open_modal,
    set_flag_open_modal,
    flag_open_modal_ver_mais,
    set_flag_open_modal_ver_mais,
    flag_open_modal_edit,
    set_flag_open_modal_edit,
    flag_open_modal_add,
    set_flag_open_modal_add,
    setMessage,
    setOpenSnackSuccess,
    setOpenSnackError,
    set_list_trabalhadores,
    set_obj_new_trabalhador,
    obj_new_trabalhador,
    set_flag_open_modal_historico_trabalhadores,
    // flag_open_modal_historico_trabalhadores,
    set_historico,
    // historico
}) => {
    const auth = useContext(AuthContext);
    const location = useLocation();


    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [campo_obrigatorio_nome, set_campo_obrigatorio_nome] = useState<boolean>(false);
    const [campo_invalido_email, set_campo_invalido_email] = useState<boolean>(false);
    const [campo_invalido_nif, set_campo_invalido_nif] = useState<boolean>(false);
    const [error_data_inicio_contrato, set_error_data_inicio_contrato] = useState<boolean>(false);
    const [error_data_fim_contrato, set_error_data_fim_contrato] = useState<boolean>(false);
    const [error_custo_hora, set_error_custo_hora] = useState<boolean>(false);

    const [flag_editado, set_flag_editado] = useState<boolean>(false);
    const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = useState<boolean>(false);
    const [open_dialog_tem_a_certeza_que_quer_eliminar, set_open_dialog_tem_a_certeza_que_quer_eliminar] = useState<boolean>(false);


    const handler_add_trabalhador = async () => {

        if (obj_new_trabalhador?.nome === undefined || obj_new_trabalhador?.nome === '') {
            set_campo_obrigatorio_nome(true)
        } else if (obj_new_trabalhador.email !== undefined && isValidEmail(obj_new_trabalhador.email) === false) {
            set_campo_invalido_email(true)

        } else if ((obj_new_trabalhador?.nif)?.length !== 0 && obj_new_trabalhador?.nif !== undefined && verify_nif(obj_new_trabalhador?.nif) === false) {
            set_campo_invalido_nif(true)
        } else if (obj_new_trabalhador.data_inicio_contrato === undefined || obj_new_trabalhador.data_inicio_contrato === '') {
            set_error_data_inicio_contrato(true)


        } else if (obj_new_trabalhador.data_fim_contrato === undefined || obj_new_trabalhador.data_fim_contrato === '') {
            set_error_data_fim_contrato(true)


        } else if (obj_new_trabalhador.data_inicio_contrato && obj_new_trabalhador.data_fim_contrato && new Date(obj_new_trabalhador.data_inicio_contrato) > new Date(obj_new_trabalhador.data_fim_contrato)) {

            setMessage("A data de início do contrato não pode ser superior à data de fim do contrato.")
            setOpenSnackError(true);
        } else {

            try {
                setIsLoading(true);
                let res = await post(auth.token.cookie_token, 'api/trabalhadores/new', {
                    payload: {
                        nome: obj_new_trabalhador?.nome === undefined ? '' : obj_new_trabalhador?.nome,
                        nif: obj_new_trabalhador?.nif === undefined ? '' : obj_new_trabalhador?.nif,
                        telefone: obj_new_trabalhador?.telefone === undefined ? '' : obj_new_trabalhador?.telefone,
                        email: obj_new_trabalhador?.email === undefined ? '' : obj_new_trabalhador?.email,
                        funcao: obj_new_trabalhador?.funcao === undefined ? '' : obj_new_trabalhador?.funcao,
                        custo_hora: obj_new_trabalhador?.custo_hora === undefined ? 0 : obj_new_trabalhador?.custo_hora?.toString().replace(',', '.'),
                        activo: obj_new_trabalhador?.activo === undefined ? true : obj_new_trabalhador?.activo,
                        disponivel: obj_new_trabalhador?.disponivel === undefined ? false : obj_new_trabalhador?.disponivel,
                        motivo_indisponivel: obj_new_trabalhador?.motivo_indisponivel === undefined ? '' : obj_new_trabalhador?.motivo_indisponivel,
                        tipo_contrato: obj_new_trabalhador?.tipo_contrato === undefined ? '' : obj_new_trabalhador?.tipo_contrato,
                        data_inicio_contrato: obj_new_trabalhador?.data_inicio_contrato === undefined ? '' : obj_new_trabalhador?.data_inicio_contrato,
                        data_fim_contrato: obj_new_trabalhador?.data_fim_contrato === undefined ? '' : obj_new_trabalhador?.data_fim_contrato,
                        id_agri: location.state,

                    }
                });
                if (list_trabalhadores.length === 0) {
                    set_list_trabalhadores([res.data.result])
                  

                } else {
                    set_list_trabalhadores((old: any) => [...old, res.data.result])
                  
                }
                setMessage(operacao_sucesso)
                setOpenSnackSuccess(true);
                setIsLoading(false);
                func_reset_all()

            } catch (error) {
                func_print("handler_add_trabalhador", error, true);
                setMessage(operacao_erro)
                setOpenSnackError(true);
                setIsLoading(false);
            }
        }

    }
    const handler_edit_trabalhador = async () => {

        if (obj_new_trabalhador?.nome === undefined || obj_new_trabalhador?.nome === '') {
            set_campo_obrigatorio_nome(true)
        } else if ((obj_new_trabalhador?.email)?.length !== 0 && obj_new_trabalhador.email !== undefined && isValidEmail(obj_new_trabalhador.email) === false) {
            set_campo_invalido_email(true)

        } else if ((obj_new_trabalhador?.nif)?.length !== 0 && obj_new_trabalhador?.nif !== undefined && verify_nif(obj_new_trabalhador?.nif) === false) {
            set_campo_invalido_nif(true)
        } else if (obj_new_trabalhador.data_inicio_contrato === undefined || obj_new_trabalhador.data_inicio_contrato === '') {
            set_error_data_inicio_contrato(true)


        } else if (obj_new_trabalhador.data_fim_contrato === undefined || obj_new_trabalhador.data_fim_contrato === '') {
            set_error_data_fim_contrato(true)


        } else if (obj_new_trabalhador.data_inicio_contrato && obj_new_trabalhador.data_fim_contrato && new Date(obj_new_trabalhador.data_inicio_contrato) > new Date(obj_new_trabalhador.data_fim_contrato)) {

            setMessage("A data de início do contrato não pode ser superior à data de fim do contrato.")
            setOpenSnackError(true);
        } else {


            try {
                setIsLoading(true);
                let res = await put(auth.token.cookie_token, 'api/trabalhadores/' + obj_new_trabalhador.id_trabalhador, {
                    payload: {
                        id_trabalhador: obj_new_trabalhador?.id_trabalhador === undefined ? 0 : obj_new_trabalhador?.id_trabalhador,
                        nome: obj_new_trabalhador?.nome === undefined ? '' : obj_new_trabalhador?.nome,
                        nif: obj_new_trabalhador?.nif === undefined ? '' : obj_new_trabalhador?.nif,
                        telefone: obj_new_trabalhador?.telefone === undefined ? '' : obj_new_trabalhador?.telefone,
                        email: obj_new_trabalhador?.email === undefined ? '' : obj_new_trabalhador?.email,
                        funcao: obj_new_trabalhador?.funcao === undefined ? '' : obj_new_trabalhador?.funcao,
                        custo_hora: obj_new_trabalhador?.custo_hora === undefined ? 0 : obj_new_trabalhador?.custo_hora?.toString().replace(',', '.'),
                        activo: obj_new_trabalhador?.activo === undefined ? true : obj_new_trabalhador?.activo,
                        disponivel: obj_new_trabalhador?.disponivel === undefined ? false : obj_new_trabalhador?.disponivel,
                        motivo_indisponivel: obj_new_trabalhador?.motivo_indisponivel === undefined ? '' : obj_new_trabalhador?.motivo_indisponivel,
                        tipo_contrato: obj_new_trabalhador?.tipo_contrato === undefined ? '' : obj_new_trabalhador?.tipo_contrato,
                        data_inicio_contrato: obj_new_trabalhador?.data_inicio_contrato === undefined ? '' : obj_new_trabalhador?.data_inicio_contrato,
                        data_fim_contrato: obj_new_trabalhador?.data_fim_contrato === undefined ? '' : obj_new_trabalhador?.data_fim_contrato,
                        id_agri: location.state,

                    }
                });

                let aux_list = list_trabalhadores.map((el) => {
                    if (el.id_trabalhador === obj_new_trabalhador.id_trabalhador) {
                        return res.data.result
                    } else {
                        return el
                    }
                })

                set_list_trabalhadores(aux_list)
                
                setMessage(operacao_sucesso)
                setOpenSnackSuccess(true);
                setIsLoading(false);
                func_reset_all()

            } catch (error) {
                func_print("handler_edit_trabalhador", error, true);
                setMessage(operacao_erro)
                setOpenSnackError(true);
                setIsLoading(false);
            }
        }

    }

    const onInputChange = (e: any) => {
        const { name, value } = e.target;
        set_flag_editado(true)
        if (name === 'custo_hora') {
            if (!/^(\d+([.,]\d+)?)$/.test(value)) {
                set_error_custo_hora(true)
            } else {
                set_error_custo_hora(false)
            }
        }

        set_obj_new_trabalhador((prev: any) => ({
            ...prev,
            [name]: value,
        }));
    }


    const func_reset_all = () => {
        set_obj_new_trabalhador(undefined);
        set_flag_open_modal_edit(false);
        set_flag_open_modal(false);
        set_campo_obrigatorio_nome(false);
        set_flag_open_modal(false);
        set_flag_editado(false)
        set_flag_open_modal_ver_mais(false);
        set_flag_open_modal_add(false);
        set_campo_invalido_email(false);
        set_campo_invalido_nif(false);
        set_error_data_fim_contrato(false);
        set_error_data_inicio_contrato(false);
        set_error_custo_hora(false);

    }
    const handleCloseDialog = () => {
        func_reset_all()
        set_flag_editado(false)
        set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
    };

    const get_info_historico = async (id: number) => {
        try {
            setIsLoading(true);
            let res = await get(auth.token.cookie_token, '/api/trabalhadores/' + id + '/historico');


            setIsLoading(false);
            return res.data.result;

        } catch (error) {
            func_print("get_info", error, true);
            setIsLoading(false);
        }
    }
    const handle_delete_trabalhador = async () => {
        try {
            setIsLoading(true);
            await del(auth.token.cookie_token, `/api/trabalhadores/${obj_new_trabalhador?.id_trabalhador}`);
            list_trabalhadores.splice(list_trabalhadores.findIndex((trabalhador) => trabalhador.id_trabalhador === obj_new_trabalhador?.id_trabalhador), 1);
            set_obj_new_trabalhador(undefined);
            set_open_dialog_tem_a_certeza_que_quer_eliminar(false);
            func_reset_all()
            setMessage(operacao_sucesso);
            setOpenSnackSuccess(true);
            setIsLoading(false);
        } catch (error) {
            func_print("handle_delete_trabalhador", error, true);
            setIsLoading(false);
            if ((error as any)?.response?.data?.message) {
                setMessage((error as any).response.data.message);
            } else {
                setMessage(operacao_erro);
            }
            setOpenSnackError(true);
        }
    }

    return (<Modal
        style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}
        open={flag_open_modal}
    >
        <div className="flex flex-col bg-white w-[70%] max-h-[80%] rounded-xl overflow-hidden">
            <div className="flex items-center justify-between w-full pr-1 pt-1 border-b border-gray-100">
                <div></div>
                <button
                    type="button"
                    onClick={() => {
                        if (flag_editado) {
                            set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                        } else {
                            set_flag_open_modal(false)
                            set_flag_open_modal_edit(false)
                            set_flag_open_modal_ver_mais(false)
                        }
                    }}
                    className=" text-gray-400 hover:text-gray-600 transition-colors border-0 outline-none cursor-pointer !bg-transparent hover:!bg-transparent"
                >
                    <CloseIcon sx={{ fontSize: 24 }} />
                </button>
            </div>



            {
                isLoading === true ?
                    loader() :
                    <>
                        <div className="flex flex-col items-center w-full flex-1 overflow-auto">

                            <div className="flex items-center justify-between mt-4 pl-5 w-full mb-4 pr-4">
                                <div className="grid grid-cols gap-2 ">

                                    <h2 className="text-xl font-semibold text-gray-800 m-0 pl-2">
                                        {
                                            flag_open_modal_edit === true ? 'Editar Trabalhador' :
                                                flag_open_modal_ver_mais === true ? 'Detalhes do Trabalhador' :
                                                    'Adicionar Trabalhador'
                                        }
                                    </h2>


                                </div>
                                {

                                    flag_open_modal_add === false && flag_open_modal_edit === false ?

                                        <div className="flex justify-between gap-2">
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    // abrir modal de custos
                                                    get_info_historico(obj_new_trabalhador?.id_trabalhador ?? 0).then((res) => {
                                                        if (res) {
                                                            set_historico(res);
                                                            set_flag_open_modal_historico_trabalhadores(true);
                                                        } else {
                                                            setMessage(operacao_erro);
                                                            setOpenSnackError(true);
                                                        }
                                                    })

                                                }}
                                                className="flex items-center justify-center rounded-xl px-3 py-2.5 text-sm font-medium text-[#c94f1e] bg-orange-50 border border-orange-200 hover:bg-orange-100 transition-colors"
                                            >
                                                Visualizar Histórico
                                            </button>
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    set_flag_open_modal_edit(true)
                                                    set_flag_open_modal_ver_mais(false)
                                                    set_flag_open_modal_add(false)

                                                }}
                                                className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                            >
                                                <EditIcon sx={{ fontSize: 18 }} />
                                            </button>

                                            <button
                                                type="button"
                                                onClick={() => {
                                                    set_open_dialog_tem_a_certeza_que_quer_eliminar(true)

                                                }}
                                                className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                            >
                                                <DeleteIcon sx={{ fontSize: 18 }} />
                                            </button>

                                        </div>
                                        : <></>
                                }

                            </div>


                            <div className="flex flex-col gap-6 w-full h-full p-5 rounded-xl bg-gray-50/80">
                                <div className="flex flex-wrap gap-6 w-full">
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Designação</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new_trabalhador?.nome || '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true || flag_open_modal_add === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Designação'
                                                            name="nome"
                                                            error={campo_obrigatorio_nome}
                                                            helperText={campo_obrigatorio_nome ? 'Campo obrigatório' : ''}
                                                            value={obj_new_trabalhador?.nome === undefined ? '' : obj_new_trabalhador?.nome}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>
                                        }
                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">NIF</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new_trabalhador?.nif || '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true || flag_open_modal_add === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='NIF'
                                                            name="nif"
                                                            error={campo_invalido_nif}
                                                            helperText={campo_invalido_nif ? 'NIF inválido' : ''}
                                                            value={obj_new_trabalhador?.nif === undefined ? '' : obj_new_trabalhador?.nif}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>
                                        }
                                    </div>
                                </div>

                                <div className="flex flex-wrap gap-6 w-full">

                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>

                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Função</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new_trabalhador?.funcao || '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true || flag_open_modal_add === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Função'
                                                            name="funcao"
                                                            value={obj_new_trabalhador?.funcao === undefined ? '' : obj_new_trabalhador?.funcao}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>
                                        }
                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Custo por Hora</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new_trabalhador?.custo_hora ?? '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true || flag_open_modal_add === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Custo por Hora'
                                                            name="custo_hora"
                                                            value={obj_new_trabalhador?.custo_hora === undefined ? '' : obj_new_trabalhador?.custo_hora}
                                                            onChange={onInputChange}
                                                            error={error_custo_hora}
                                                            helperText={error_custo_hora ? 'Custo por hora deve ser um número' : ''}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>}
                                    </div>
                                </div>

                                <div className="flex flex-wrap gap-6 w-full">
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Telefone</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new_trabalhador?.telefone || '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true || flag_open_modal_add === true ?
                                                    <div className="md:col-span-2 w-full pt-4">

                                                        <div
                                                            style={{
                                                                flex: 0.5,
                                                                display: "flex",
                                                                flexDirection: 'row',
                                                                justifyContent: "center",
                                                                alignSelf: "center",
                                                                alignItems: "center",
                                                                border: `1px solid silver`,
                                                                fontSize: 14,
                                                                borderRadius: 4,
                                                                marginRight: 3,
                                                                width: "100%",
                                                                paddingRight: "5px",
                                                            }}
                                                        >
                                                            <PhoneInput
                                                                name="telefone"
                                                                defaultCountry="PT"
                                                                placeholder="Número de telefone"
                                                                value={"+351" + (obj_new_trabalhador?.telefone === null ? '' : obj_new_trabalhador?.telefone)}
                                                                onChange={(e: any) => {
                                                                    set_flag_editado(true)

                                                                    set_obj_new_trabalhador((prevCaderno: any) => ({
                                                                        ...prevCaderno,
                                                                        'telefone': e.slice(-9),
                                                                    }));
                                                                }}
                                                                style={{
                                                                    width: "90%",
                                                                    height: 51,
                                                                }}
                                                            />
                                                        </div>
                                                    </div> : <></>}
                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Email</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new_trabalhador?.email || '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true || flag_open_modal_add === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Email'
                                                            name="email"
                                                            error={campo_invalido_email}
                                                            helperText={campo_invalido_email ? 'Email inválido' : ''}
                                                            value={obj_new_trabalhador?.email === undefined ? '' : obj_new_trabalhador?.email}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>}
                                    </div>
                                </div>
                                <div className="flex flex-wrap gap-6 w-full">

                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Inicio de Contrato</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new_trabalhador?.data_inicio_contrato || '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true || flag_open_modal_add === true ?

                                                    <div className="w-full">
                                                        <TextField
                                                            variant="outlined"
                                                            label="Inicio de Contrato"
                                                            name="data_inicio_contrato"
                                                            type="date"
                                                            error={error_data_inicio_contrato}
                                                            helperText={error_data_inicio_contrato ? 'Data obrigatória' : ''}
                                                            value={obj_new_trabalhador?.data_inicio_contrato === undefined ? '' : obj_new_trabalhador?.data_inicio_contrato}

                                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                                set_flag_editado(true)

                                                                set_obj_new_trabalhador((old: any) => ({
                                                                    ...old,
                                                                    'data_inicio_contrato': event.target.value,
                                                                }));

                                                            }}
                                                            fullWidth
                                                            margin="normal"
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div>
                                                    : <></>}
                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Fim de Contrato</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new_trabalhador?.data_fim_contrato ?? '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true || flag_open_modal_add === true ?


                                                    <div className="w-full">
                                                        <TextField
                                                            variant="outlined"
                                                            label="Fim de Contrato"
                                                            name="data_fim_contrato"
                                                            type="date"
                                                            error={error_data_fim_contrato}
                                                            helperText={error_data_fim_contrato ? 'Data obrigatória' : ''}
                                                            value={obj_new_trabalhador?.data_fim_contrato === undefined ? '' : obj_new_trabalhador?.data_fim_contrato}

                                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                                set_flag_editado(true)

                                                                set_obj_new_trabalhador((old: any) => ({
                                                                    ...old,
                                                                    'data_fim_contrato': event.target.value,
                                                                }));

                                                            }}
                                                            fullWidth
                                                            margin="normal"
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div>

                                                    : <></>}
                                    </div>
                                </div>
                                {/* row 2: switches */}
                                <div className="flex flex-wrap gap-6 w-full">
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-3">

                                        <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Ativo</div>

                                        <Switch
                                            height={22}
                                            width={44}
                                            onColor={cores.cor1}
                                            offColor="#e5e7eb"
                                            onChange={() => {

                                                set_flag_editado(true)

                                                set_obj_new_trabalhador((old: any) => ({
                                                    ...old,
                                                    'activo': !obj_new_trabalhador?.activo,
                                                }));
                                            }}
                                            checked={obj_new_trabalhador?.activo ?? false}
                                            disabled={flag_open_modal_ver_mais === true ? true : false}

                                        />

                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-3">
                                        <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Disponível</div>
                                        <Switch
                                            height={22}
                                            width={44}
                                            onColor={cores.cor1}
                                            offColor="#e5e7eb"
                                            onChange={() => {

                                                set_flag_editado(true)

                                                set_obj_new_trabalhador((old: any) => ({
                                                    ...old,
                                                    'disponivel': !obj_new_trabalhador?.disponivel,
                                                }));
                                            }}
                                            checked={obj_new_trabalhador?.disponivel ?? false}
                                            disabled={flag_open_modal_ver_mais === true ? true : false}

                                        />
                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-3">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Motivo Indisponível</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new_trabalhador?.motivo_indisponivel ?? '-'}</div>
                                            </>
                                                :
                                                (flag_open_modal_edit === true || flag_open_modal_add === true) && obj_new_trabalhador?.disponivel ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Motivo Indisponível'
                                                            name="motivo_indisponivel"
                                                            value={obj_new_trabalhador?.motivo_indisponivel === undefined ? '' : obj_new_trabalhador?.motivo_indisponivel}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>}
                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-3">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Tipo de Contrato</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new_trabalhador?.tipo_contrato ?? '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true || flag_open_modal_add === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Tipo de Contrato'
                                                            name="tipo_contrato"
                                                            value={obj_new_trabalhador?.tipo_contrato === undefined ? '' : obj_new_trabalhador?.tipo_contrato}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>}
                                    </div>
                                </div>

                                {flag_open_modal_ver_mais === true ? <></> :
                                    <div className="flex justify-end w-full pt-4">
                                        <button
                                            type="button"
                                            onClick={() => {


                                                if (obj_new_trabalhador?.nome === undefined || obj_new_trabalhador.nome === '') {
                                                    set_campo_obrigatorio_nome(true);
                                                } else {

                                                    set_campo_obrigatorio_nome(false);
                                                    if (flag_open_modal_edit === true && flag_open_modal_add === false) {
                                                        handler_edit_trabalhador()
                                                    } else if (flag_open_modal_add === true) {
                                                        handler_add_trabalhador()
                                                    }
                                                }
                                            }}
                                            className="px-5 py-2.5 mt-4 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                        >
                                            Guardar Informação
                                        </button>
                                    </div>
                                }
                            </div>




                        </div>
                    </>
            }
            <ConfirmDialog
                open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
                onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
                onConfirm={() => handleCloseDialog()}
                message={mensagem_tem_a_certeza_de_apagar_alteracoes}
            />
            <ConfirmDialog
                open={open_dialog_tem_a_certeza_que_quer_eliminar}
                onClose={() => set_open_dialog_tem_a_certeza_que_quer_eliminar(false)}
                onConfirm={handle_delete_trabalhador}
                message="Deseja eliminar o registo?"
            />
        </div>



    </Modal>)

}
